import _regeneratorRuntime from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import { getConfigValue } from '@jutro/config';
import { warning, info } from '@jutro/logger';
import { fetchTsmLanguages } from './fetchTsmLanguages';
export var tsmLanguagesLoader = function tsmLanguagesLoader() {
  var worksetUid, stringVersion, stringGroup, config, jutroVersion, languages;
  return _regeneratorRuntime.async(function tsmLanguagesLoader$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          worksetUid = getConfigValue('JUTRO_TSM_WORKSET_UID', 'active');
          stringVersion = getConfigValue('JUTRO_TSM_STRING_VERSION');
          stringGroup = getConfigValue('JUTRO_TSM_STRING_GROUP');
          config = getConfigValue('localeSettings');
          jutroVersion = getConfigValue('JUTRO_CORE_STRING_VERSION');
          info("TSM enabled: Loading available languages, worksetUid: \"".concat(worksetUid, "\", string group: \"").concat(stringGroup, ":."));
          _context.prev = 6;
          _context.next = 9;
          return _regeneratorRuntime.awrap(fetchTsmLanguages(worksetUid, stringGroup, undefined, stringVersion, jutroVersion));

        case 9:
          languages = _context.sent;
          config.availableLanguages = languages.languageCodes;
          config.preferredLanguage = languages.defaultLanguageCode;
          _context.next = 17;
          break;

        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](6);
          warning("TSM: Error loading languages. Details: ".concat(_context.t0));

        case 17:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, [[6, 14]], Promise);
};